/**
 * @description 自定义常量
 * @created 2024/04/19 15:48:51
 */

// 自定义SPU
export const CUSTOM_SPU = "S7058#"
// 自定义色号
export const CUSTOM_COLOR_CODE = "002#"

// 自定义纸筒重量
export const CUSTOM_PAPER_TUBE_WEIGHT = 0.3
// 自定义包装重量
export const CUSTOM_PACKAGE_WEIGHT = 0.15
